import { PasswordFill18Icon } from "@vygruppen/spor-icon-react";
import { CompositionPosition } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/types";
import { getVehicleImage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/vehicleImages";
import { useTranslation } from "react-i18next";
import { HStack } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import unknownVehicle from "shared/icons/unknown-carriage.gif";
import styled from "styled-components";

const VehicleCompositionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  text-wrap: none;
`;

const Composition = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const sortByDescPosition = (compositions: CompositionPosition[]) =>
  compositions.sort((a, b) => {
    if (!b.position) {
      return -1;
    }

    if (!a.position) {
      return 1;
    }

    return +b.position - +a.position;
  });

type VehicleCompositionProps = {
  compositions: CompositionPosition[];
};

export const VehicleComposition = ({
  compositions,
}: VehicleCompositionProps) => {
  const { t } = useTranslation();
  return (
    <VehicleCompositionWrapper>
      {sortByDescPosition(compositions).map((comp) => (
        <Composition
          key={`${comp.vehicleID}_${comp.position}_${comp.vehicleType}`}
        >
          <HStack>
            {!comp.closed &&
              (comp.carriageNumber ? (
                <Text>{comp.carriageNumber}</Text>
              ) : (
                <Text>&nbsp;</Text>
              ))}
            {comp.closed && (
              <div
                style={{
                  height: "22px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PasswordFill18Icon />
              </div>
            )}
          </HStack>

          <object
            data={getVehicleImage(comp.vehicleType, comp.orientation)}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              flexGrow: 1,
            }}
            aria-describedby={`label-${comp.vehicleID}-${comp.position}`}
          >
            <img alt={t("Ukjent kjøretøy")} src={unknownVehicle} />
          </object>

          <Text
            id={`label-${comp.vehicleID}-${comp.position}`}
            style={{ marginTop: "6px" }}
          >
            {comp.vehicleType}
          </Text>
        </Composition>
      ))}
    </VehicleCompositionWrapper>
  );
};
